import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SoccerBallIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M11.6625 6.60528C11.515 6.64247 11.3586 6.60991 11.2377 6.51682L8.94647 4.75228C8.82265 4.65692 8.75 4.50882 8.75 4.35173V1.59971C8.75 1.3002 9.00817 1.06529 9.30016 1.12058C11.6411 1.56382 13.571 3.18178 14.4645 5.34402C14.5762 5.61425 14.4121 5.91233 14.1303 5.98333L11.6625 6.60528Z"
		></path>
		<path
			fill="currentColor"
			d="M14.9986 7.91286C14.9925 7.60587 14.699 7.39871 14.4035 7.47318L11.9494 8.09168C11.7797 8.13443 11.6446 8.26343 11.5929 8.43186L10.9021 10.6854C10.8548 10.8397 10.8837 11.0075 10.9798 11.1367L12.3025 12.9145C12.4775 13.1498 12.8157 13.1856 13.019 12.9748C14.245 11.7038 15 9.96866 15 8.05578C15 8.00803 14.9995 7.96039 14.9986 7.91286Z"
		></path>
		<path
			fill="currentColor"
			d="M10.891 14.4844C11.1668 14.3582 11.2403 14.007 11.0585 13.7627L9.96274 12.2898C9.86832 12.1629 9.72012 12.0882 9.56274 12.0882H6.43726C6.27988 12.0882 6.13168 12.1629 6.03726 12.2898L4.94148 13.7627C4.75973 14.007 4.83316 14.3582 5.10898 14.4844C5.99024 14.8878 6.96909 15.1125 8 15.1125C9.03091 15.1125 10.0098 14.8878 10.891 14.4844Z"
		></path>
		<path
			fill="currentColor"
			d="M2.98097 12.9748C3.18433 13.1856 3.52247 13.1498 3.69749 12.9145L5.02016 11.1367C5.11627 11.0075 5.14516 10.8397 5.09787 10.6854L4.40708 8.43186C4.35545 8.26343 4.22028 8.13443 4.05063 8.09168L1.59654 7.47318C1.30105 7.39871 1.00746 7.60587 1.00141 7.91286C1.00047 7.96039 1 8.00803 1 8.05578C1 9.96866 1.755 11.7038 2.98097 12.9748Z"
		></path>
		<path
			fill="currentColor"
			d="M1.53551 5.34402C1.42384 5.61425 1.58795 5.91233 1.86966 5.98333L4.33747 6.60528C4.48504 6.64247 4.64139 6.60992 4.76227 6.51682L7.05353 4.75228C7.17736 4.65692 7.25 4.50882 7.25 4.35173V1.59971C7.25 1.3002 6.99183 1.06529 6.69984 1.12058C4.35895 1.56382 2.42905 3.18178 1.53551 5.34402Z"
		></path>
		<path
			fill="currentColor"
			d="M8.30353 6.16004C8.12433 6.02203 7.87567 6.02203 7.69647 6.16004L6.0192 7.45174C5.85269 7.57997 5.78315 7.79927 5.84502 8.0011L6.52543 10.2208C6.59017 10.432 6.78387 10.576 7.00314 10.576H8.99686C9.21614 10.576 9.40983 10.432 9.47457 10.2208L10.155 8.0011C10.2168 7.79927 10.1473 7.57997 9.9808 7.45174L8.30353 6.16004Z"
		></path>
	</svg>
))
